import type { BotDifficulty } from '@cribbage/bots';
import type { RigConfig } from './AvatarRig.js';

/** A level's rig: its cast slug and the folder `cut.py export` writes its layers to. */
function botRig(level: BotDifficulty): RigConfig {
  return { slug: `bot-${level}`, dir: `/avatars/bots/${level}`, wholeBust: true, chinDrawings: [] };
}

/**
 * The face a bot seat wears: one tin robot per level, animated by `AvatarRig`.
 * The four are drawn as one robot (`docs/dev/avatars.md`, House bots), so a
 * level reads at a glance: Hard wears armor and a red lens, Expert a crown.
 *
 * Each is a continuous bust with independent eye patches and no chin layer.
 * The layers ship from `public/avatars/bots/<level>/` and are precached, so
 * an offline bot game draws them too. `cut.py export` writes them there.
 */
export const BOT_RIGS: Readonly<Record<BotDifficulty, RigConfig>> = {
  easy: botRig('easy'),
  medium: botRig('medium'),
  hard: botRig('hard'),
  expert: botRig('expert'),
};
